import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { colors } from "../../styles/colors";
import { textStyles } from "../../styles/typography";

export const HeaderSection = styled("header") <{ $isScrolled: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 80px;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
  background: ${({ $isScrolled }) =>
    $isScrolled
      ? `${colors.background.primary}B4`
      : 'transparent'
  };
  backdrop-filter: ${({ $isScrolled }) =>
    $isScrolled ? 'blur(10px)' : 'none'
  };
  box-shadow: ${({ $isScrolled }) =>
    $isScrolled
      ? `0 4px 20px ${colors.shadow.dark}`
      : 'none'
  };
  border-bottom: ${({ $isScrolled }) =>
    $isScrolled
      ? `1px solid ${colors.neutral.border}20`
      : 'none'
  };
  transition: background 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
              backdrop-filter 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
              box-shadow 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              border-bottom 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: ${({ $isScrolled }) =>
    $isScrolled
      ? `${colors.background.primary}F2`
      : 'none'
  };
    box-shadow: ${({ $isScrolled }) =>
    $isScrolled
      ? `0 6px 25px ${colors.shadow.dark}`
      : 'none'
  };
  }

  .ant-row-space-between {
    align-items: center;
    text-align: center;
    height: 100%;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  flex: 0 0 auto;
  min-width: 0;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;

  svg {
    fill: ${colors.neutral.white};
  }
`;

export const NotHidden = styled("div")`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 32px;
  flex: 1 1 auto;
  min-width: 0;

  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: ${colors.neutral.white};
  transition: color 0.2s ease-in;
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;

  @media only screen and (max-width: 890px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  ${textStyles.heading("h5")}
  color: ${colors.neutral.white};
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  outline: none;

  &:hover,
  &:active {
    color: ${colors.secondary.main};
    text-underline-position: under;
    text-decoration: ${colors.secondary.main} underline;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }
`;
